<script>
  import { onMount, tick } from "svelte";
  import { querystring, push, location, replace, pop } from "svelte-spa-router";
  import { routes } from "../routes.js";
  import Router from "svelte-spa-router";
  import Authenticate from "./Authenticate.svelte";
  import Popup from "./Popup.svelte";
  import Toast from "./Toast.svelte";

  import { get } from "svelte/store";

  import {
    popup,
    showPopup as showPopupFunc,
    loading,
    showSplash,
    showSectionsSlider,
    scrollY,
    OS,
    isWebOnMobile,
    forwardToApp,
  } from "../stores.js";
  import Nav from "./Nav.svelte";
  import { fade } from "svelte/transition";
  import PullToRefresh from "pulltorefreshjs";
  import { acceptedCookies, myOrder } from "../stores.js";
  import CookiesWarning from "./CookiesWarning.svelte";
  import Loading from "./Loading.svelte";
  import * as InitService from "../bl/init-service";
  import * as CordovaDB from "../dal/cordova-db-wrapper";
  import * as CordovaAuth from "../dal/cordova-auth-wrapper";
  import * as WebDB from "../dal/web-db-wrapper";
  import * as WebAuth from "../dal/web-auth-wrapper";

  import { isOffline } from "svelte-connection-status";
  import IsOffline from "./IsOffline.svelte";
  import { gotoApp } from "../utils.js";
  import StackTrace from "stacktrace-js";

  let showAuth = false;

  let showPopup = false;

  let windowLoaded = false;

  let nav;

  let deferredPrompt;

  let installed = true;

  let lastScrollY = 0;

  let content; //content div

  // const ptr = PullToRefresh.init({
  //   mainElement: "body",
  //   onRefresh() {
  //     window.location.reload();
  //   },
  // });

  onMount(async () => {
    // window.onunhandledrejection = async (e) => {
    //   const message = e.reason ?? e.toString();
    //   // alert(`אופס, משהו השתבש. אנא נסו לטעון שוב את הדף\n${message}`);
    //   try {
    //     await UserDAL.sendLog("onunhandledrejection", message);
    //   } catch (e) {
    //     console.error("could not log error");
    //   }
    //   // window.location.reload();
    // };

    if (window.cordova) {
      // var appRootURL = window.location.href.replace("index.html", "");

      const os = get(OS);
      window.db = CordovaDB;
      window.auth = CordovaAuth;
      document.addEventListener(
        "deviceready",
        async () => {
          console.log("device ready");

          window.onerror = function (errorMsg, url, line, col, error) {
            var logMessage = errorMsg;
            var stackTrace = null;

            var sendError = function () {
              FirebasePlugin.logError(
                logMessage,
                stackTrace,
                function () {
                  console.log("Sent JS exception");
                },
                function (error) {
                  console.error("Failed to send JS exception", error);
                }
              );
            };

            logMessage += ": url=" + url;
            // url.replace(appRootURL, "") +
            "; line=" + line + "; col=" + col;

            if (typeof error === "object") {
              StackTrace.fromError(error).then(function (trace) {
                stackTrace = trace;
                sendError();
              });
            } else {
              sendError();
            }
          };

          // Send a non-fatal error
          FirebasePlugin.logError(
            "A non-fatal error",
            function () {
              console.log("Sent non-fatal error");
            },
            function (error) {
              console.error("Failed to send non-fatal error", error);
            }
          );

          InitService.init();
          const remoteLoadingCode = SettingsDAL.getRemoteLoadingCode();
          debugger;
          if (remoteLoadingCode != null) {
            eval(remoteLoadingCode);
          }
        },
        false
      );
    } else {
      window.db = WebDB;
      window.auth = WebAuth;
      InitService.init();
    }
  });

  querystring.subscribe((qs) => {
    showAuth = qs.search("showAuth=true") != -1;
    showPopup = qs.search("showPopup=true") != -1;

    if (showPopup && !$popup.callback) {
      showPopup = false;
      replace($location);
    }
  });

  function scrollTo(e) {
    content.removeEventListener("scroll", contentScroll);
    document.getElementById(e.detail).scrollIntoView({ behavior: "smooth" });
    $showSectionsSlider = false;
    setTimeout(() => {
      content.addEventListener("scroll", contentScroll);
      if (content.scrollTop < 30) {
        $showSectionsSlider = true;
      }
    }, 1000);
  }

  function contentScroll(e) {
    const y = e.target.scrollTop;
    $showSectionsSlider = y < lastScrollY;
    lastScrollY = y;
    $scrollY = y;
  }

  async function promptInstall() {
    if (!installed) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome == "accepted") {
        console.log(outcome);
        deferredPrompt = null;
        installed = true;
      }
    }
  }

  let loaded = false;

  async function allLoaded() {
    await tick();
    loaded = true;
  }

  $: {
    if (windowLoaded && $myOrder != "loading") {
      allLoaded();
    }
  }

  function scrollToTop() {
    content.scrollTo(0, 0);
  }

</script>

<svelte:window
  on:load={() => {
    windowLoaded = true;
  }}
  on:beforeinstallprompt={(e) => {
    installed = false;
    e.preventDefault();
    // Stash the event so it can be triggered later.
    deferredPrompt = e;
    // Optionally, send analytics event that PWA install promo was shown.
    console.log(`'beforeinstallprompt' event was fired.`);
  }}
  on:appinstalled={(e) => {
    console.log(e);
  }}
/>

{#if !loaded || $myOrder == 'loading' || $showSplash}
  <div class="splash" transition:fade={{ duration: 350 }}>
    <img src="images/logo_white.svg" alt="Loading" />
  </div>
{/if}
<Nav bind:this={nav} on:promptInstall={promptInstall} {installed} />

<div class="content" on:scroll={contentScroll} bind:this={content}>
  {#if showAuth}
    <Authenticate />
  {/if}

  {#if showPopup}
    <Popup />
  {/if}
  <Router {routes} on:routeEvent={scrollTo} on:routeLoaded={scrollToTop} />
</div>

{#if !$acceptedCookies}
  <CookiesWarning />
{/if}

{#if $loading}
  <Loading />
{/if}

<!-- {#if window.environment === 'staging'}
  <div class="isStaging">STAGING</div>
{/if} -->

{#if $isOffline}
  <IsOffline />
{/if}

{#if $isWebOnMobile && $forwardToApp.includes($OS)}
  <div class="getApp" on:click={gotoApp}>
    <img src="images/phone-icon.svg" alt="" />פתיחה באפליקציה
  </div>
{/if}

<Toast />

<style>
  .getApp {
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    box-shadow: 0 1px 4px #00000070;
    z-index: 1;
  }

  .getApp > img {
    width: 40px;
    filter: brightness(0.3);
  }
  :global(html) {
    overflow: hidden;
    user-select: none;
  }

  :global(body, html, :root) {
    /* background: linear-gradient(45deg, #ffe0c3, #fffee2); */
    display: flex;
    flex-direction: column;
    background: hsl(0deg 0% 97.5%);
    padding: 0;
    margin: 0;
    font-size: 10px;
    --blue1: #6ecaff;
    --blue2: #edf9ff;
    --red1: #ff5c5c;
    --red2: #ff5c5c66;
    --green1: #35e541;
    --grey1: #4b4b4b;
    --orange1: #ffb44b96;
    --nav-bar-height: 65px;
    font-family: "Rubik";
  }

  :global(a, a:visited) {
    color: unset;
    text-decoration: unset;
  }

  :global(img) {
    display: block;
  }

  :global(::-webkit-scrollbar) {
    width: 10px;
    height: 10px;
  }
  :global(::-webkit-scrollbar-button) {
    width: 0px;
    height: 0px;
  }
  :global(::-webkit-scrollbar-thumb) {
    background: #ffffff;
    border: 0px none #ffffff;
    border-radius: 0px;
  }
  :global(::-webkit-scrollbar-thumb:hover) {
    background: #ffffff;
  }
  :global(::-webkit-scrollbar-thumb:active) {
    background: #000000;
  }
  :global(::-webkit-scrollbar-track) {
    background: #666666;
    border: 0px none #ffffff;
    border-radius: 0px;
  }
  :global(::-webkit-scrollbar-track:hover) {
    background: #666666;
  }
  :global(::-webkit-scrollbar-track:active) {
    background: #333333;
  }
  :global(::-webkit-scrollbar-corner) {
    background: transparent;
  }

  :global(.invalidInput) {
    border: 1.5px solid var(--red1);
    outline: var(--red1);
    background: #ff5c5c33;
  }

  .content {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: auto;
    box-sizing: border-box;
  }

  .splash {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(55deg, #50dfff, #00a2ff);
    z-index: 10009;
  }

  .splash > img {
    width: 200px;
    height: 200px;
  }

  @keyframes -global-rotate {
    0% {
      transform: rotate(360deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }

</style>
